import { useLocation } from '@/hooks/useLocation';
import BaseService from '@/services/base-service';
import { appendLocationToQueryParams } from '@/utils/interceptors';

class Offers extends BaseService {
	constructor() {
		super({
			serviceName: 'Offers',
			customOptions: {
				interceptors: {
					request: appendLocationToQueryParams,
				},
			},
		});
	}

	public getOffers(context: string): Promise<any> {
		return this.client.get(`/offers`, {
			params: {
				context,
			},
		});
	}
	public getpdpOffers(context: string, payload: any): Promise<any> {
		return this.client.post(`/offers/product-offers?`, payload, {
			params: {
				context,
			},
		});
	}
}

export const offerService = new Offers();
